document.addEventListener('DOMContentLoaded', () => {
  const legacyDestinations = new Set(['/products/framed-canvas', '/collections/all']);
  const homeAreas = document.querySelectorAll('.swa-home, .swa-beyond, .swa-story-cards, .swa-interactive, .swa-late-steps, .swa-final-cta, .swa-trust-cta');
  const primaryLabels = new Set(['shop artwork', 'shop all gifts', 'find your keepsake', 'start creating', 'create yours', 'create your keepsake']);

  homeAreas.forEach((area) => {
    area.querySelectorAll('a[href]').forEach((link) => {
      const path = new URL(link.href, location.origin).pathname;
      if (!legacyDestinations.has(path)) return;
      link.href = '/pages/create-keepsake';
      if (primaryLabels.has(link.textContent.trim().toLowerCase())) link.textContent = 'Create your keepsake';
    });
  });
});
